import { useEffect, useRef } from "react";
import { Button } from "@jsq/ds/core";
import { useFormContext } from "@jsq/ds/forms";
import { useInvestorWizard } from "../context";

interface Props {
  onBack: () => void;
}

/**
 * Bridges a profile form's submit into the wizard's shared sticky footer. Rendered inside the
 * form so it can reach Formik's submit, while the buttons themselves render in the footer slot.
 * Handlers are read through refs so re-registering only happens when the submit state changes,
 * avoiding a render loop with the footer-content provider.
 */
export const ProfileFormFooter = ({ onBack }: Props) => {
  const { setFooterContent } = useInvestorWizard();
  const { submitForm, isSubmitting } = useFormContext();

  const onBackRef = useRef(onBack);
  onBackRef.current = onBack;
  const submitRef = useRef(submitForm);
  submitRef.current = submitForm;

  useEffect(() => {
    setFooterContent(
      <>
        <Button variant="neutral" onClick={() => onBackRef.current()}>
          Back
        </Button>
        <Button
          variant="primary"
          disabled={isSubmitting}
          onClick={() => void submitRef.current()}
        >
          Continue
        </Button>
      </>,
    );
    return () => setFooterContent(null);
  }, [setFooterContent, isSubmitting]);

  return null;
};
